import { FieldRow, PolicyField, useFinalizeFieldRules } from '../../policy';
import { TransportDetails } from './TransportDetails';

interface FinalizeTransportProps {
  disabled: boolean;
}

export const FinalizeTransport: React.FC<FinalizeTransportProps> = ({ disabled }) => {
  const { form, fieldProps } = useFinalizeFieldRules({ section: 'transport' });

  return (
    <>
      <FieldRow mb="sm">
        <PolicyField {...fieldProps('consignment.countryOfDispatch')} span={6} disabledWhen={!form.values.consignment.countryOfDispatchHeader} />
        <PolicyField {...fieldProps('consignment.countryOfExport')} span={6} disabledWhen={!form.values.consignment.countryOfExportHeader} />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyField {...fieldProps('consignment.countryOfDestination')} span={6} disabledWhen={!form.values.consignment.destinationHeader} />
        <PolicyField {...fieldProps('consignment.regionOfDestination')} span={6} disabledWhen={!form.values.consignment.destinationHeader} />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyField {...fieldProps('consignment.carrier')} span={6} eucdm={false} />
      </FieldRow>

      <TransportDetails disabled={disabled} />

      <FieldRow mb="sm">
        <PolicyField {...fieldProps('valuationInformationTaxes.deliveryTerms.incotermCode')} span={4} />
        <PolicyField {...fieldProps('valuationInformationTaxes.deliveryTerms.location')} span={4} />
        <PolicyField {...fieldProps('valuationInformationTaxes.deliveryTerms.country')} span={4} />
      </FieldRow>
    </>
  );
};
